import { useQueryClient } from "@tanstack/react-query";
import appHomeEntryClient, { AppHomeEntry } from "../../../api/appHomeEntry";
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from "../../../components/hooks/useKlydoMutation";

const useUpdateAppHomeEntryMutation = (
  options?: UseKlydoMutationOptions<AppHomeEntry, AppHomeEntry, unknown>,
) => {
  const queryClient = useQueryClient();
  return useKlydoMutation({
    mutationFn: (entry: AppHomeEntry) => {
      return appHomeEntryClient.updateAppHomeEntry(entry.id, entry);
    },
    onSuccess: (entry, variables, context) => {
      queryClient.setQueryData(["app-home-entry", entry.id], entry);
      queryClient.invalidateQueries({
        queryKey: ["app-home-entry"],
      });
      options?.onSuccess?.(entry, variables, context);
    },
  });
};
export default useUpdateAppHomeEntryMutation;
